import { render, staticRenderFns } from "./PostTemplateEditor.vue?vue&type=template&id=be9ae404"
import script from "./PostTemplateEditor.vue?vue&type=script&lang=js"
export * from "./PostTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./PostTemplateEditor.vue?vue&type=style&index=0&id=be9ae404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports